/**
 * 특정 딥링크를 Home 스크린의 특정 탭으로 매핑.
 * `useOpenDeeplink`에서 이 매핑에 매치되면 bridge 대신 RN navigation으로
 * Home 탭을 직접 설정합니다.
 *
 * 확장 시 `HOME_TAB_BY_DEEPLINK_PATH`에 패턴을 추가하세요.
 */

type HomeTabMapping = {
  /** HomeContents의 `item.route.screen_name`과 매칭되는 값 */
  screenName: string;
  /** 딥링크 쿼리에서 함께 실어 보낼 파라미터 키 */
  passQueryKeys?: readonly string[];
};

/** key: `ably://` 뒤의 path 부분 (예: `ranking/market`) */
const HOME_TAB_BY_DEEPLINK_PATH: Record<string, HomeTabMapping> = {
  'ranking/market': {
    screenName: 'MARKET_RANKING',
    passQueryKeys: ['market_type_sno'],
  },
};

export type HomeTabDeeplinkResult = {
  screenName: string;
  params: Record<string, string>;
};

const getQueryValue = (query: string, key: string): string | null => {
  const match = query.match(new RegExp(`(?:^|&)${key}=([^&]*)`));
  return match ? match[1] : null;
};

export const resolveHomeTabFromDeeplink = (
  link: string,
): HomeTabDeeplinkResult | null => {
  const match = link.match(/^ably:\/\/([^?]+?)\/?(?:\?(.*))?$/);
  if (!match) return null;
  const path = match[1];
  const query = match[2] ?? '';

  const mapping = HOME_TAB_BY_DEEPLINK_PATH[path];
  if (!mapping) return null;

  const params: Record<string, string> = {};
  if (mapping.passQueryKeys && query) {
    for (const key of mapping.passQueryKeys) {
      const value = getQueryValue(query, key);
      if (value != null) params[key] = value;
    }
  }
  return { screenName: mapping.screenName, params };
};
